<template>
  <div
    v-if="data"
    id="waybill-print"
    class="sheet padding-10mm A4"
  >
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <tr>
        <td
          width="300"
          class="top"
        >
          <div style="height: 150px">
            <img
              src="@/assets/unisavdo_logo.svg"
              width="150"
              alt=""
            >
          </div>
        </td>
        <td
          width="345"
          class="top"
          style="padding-left: 30px;text-align: center"
        >
          <div
            v-if="data.payment_method === 'ON_PREMISE'"
            style="border:2px solid #000000;padding:5px; margin-bottom: 10px"
          >
            <strong>USTAMA TO'LOV/НАЛОЖЕННЫЙ ПЛАТЁЖ<br> {{ data.total_price + data.delivery_cost + data.buyer_commission_cost | currency }}</strong>
          </div>
          <VueBarcode :value="data.tracking_number" />
        </td>
      </tr>
    </table>
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <tr>
        <td
          width="300"
          class="top"
        >
          <p>Aloqa korxonasi indeksi va jo’natuvchi adresi</p>
          <table
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td class="bb">
                {{ data.store.title }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.store.address }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.store.zip_code }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.store.phone | phoneFormatter }}
              </td>
            </tr>
          </table>
        </td>
        <td
          width="345"
          class="top"
          style="padding-left: 30px"
        >
          <p>&nbsp;</p>
          <table
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td class="bb">
                {{ data.buyer.name }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.buyer.address }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.buyer.zip_code }}
              </td>
            </tr>
            <tr>
              <td class="bb">
                {{ data.buyer.phone | phoneFormatter }}
                <span
                  v-if="data.buyer.additional_phone"
                  style="margin-left: 5rem;"
                >
                  {{ data.buyer.additional_phone | phoneFormatter }}
                </span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <div class="page-break" />
    <p
      style="margin-top: 50px"
      align="right"
    >
      ф.103
    </p>
    <p
      style="margin-top: 20px"
      align="center"
    >
      <strong>СПИСОК ___</strong>
    </p>
    <p style="margin-top: 20px">
      «___»___________20__ г.
    </p>
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <tr>
        <td
          width="300"
          class="top"
          style="border-bottom: 1px solid #000000"
        />
        <td
          width="100"
          style="text-align: center;"
        >
          поданных в
        </td>
        <td
          width="345"
          class="top"
          style="text-align: right;padding:0;border-bottom: 1px solid #000000;"
        />
      </tr>
      <tr>
        <td
          width="300"
          class="middle"
          style="padding:0"
        >
          (вид почтовых отправлений)
        </td>
        <td />
        <td
          width="345"
          class="middle"
          style="text-align: right;padding:0"
        >
          (наименование объекта почтовой связи)
        </td>
      </tr>
    </table>
    <p style="margin-top: 50px">
      {{ data.store.title }}, {{ data.store.tin }}, {{ data.store.address }}
    </p>
    <table
      v-if="data.products && data.products.length > 0"
      class="table-bordered"
    >
      <tr>
        <td
          width="35"
          class="top"
        >
          № п.п.
        </td>
        <td
          width="51"
          class="top"
        >
          Куда
        </td>
        <td
          width="84"
          class="top"
        >
          Кому (ФИО адресата)
        </td>
        <td
          width="78"
          class="top"
        >
          Стоимость товаров, сум
        </td>
        <td
          width="39"
          class="top"
        >
          Вес, кг
        </td>
        <td
          width="83"
          class="top"
        >
          Плата за пересылку, сум
        </td>
        <td
          width="92"
          class="top"
        >
          Комиссия за наложенный платеж, сум
        </td>
        <td
          width="96"
          class="top"
        >
          Сумма наложенного платежа
        </td>
        <td
          width="103"
          class="top"
        >
          Штрихкоды почтовых отправлений
        </td>
      </tr>
      <tr>
        <td
          width="35"
          class="top"
        >
          1
        </td>
        <td
          width="51"
          class="top"
        >
          {{ data.buyer.region }}
        </td>
        <td
          width="84"
          class="top"
        >
          {{ data.buyer.name }}
        </td>
        <td
          width="78"
          class="top"
        >
          {{ data.total_price | currency }}
        </td>
        <td
          width="39"
          class="top"
        >
          {{ data.weight/1000 }}
        </td>
        <td
          width="83"
          class="top"
        >
          {{ data.delivery_cost | currency }}
        </td>
        <td
          v-if="data.payment_method === 'ON_PREMISE'"
          width="92"
          class="top"
        >
          {{ data.buyer_commission_cost | currency }}
        </td> <td v-else>
          -
        </td>
        <td
          v-if="data.payment_method === 'ON_PREMISE'"
          width="96"
          class="top"
        >
          {{ data.total_price + data.delivery_cost + data.buyer_commission_cost | currency }}
        </td> <td v-else>
          -
        </td>
        <td
          width="103"
          class="top"
        >
          {{ data.tracking_number }}
        </td>
      </tr>
    </table>
    <table style="margin-top: 40px">
      <tr>
        <td class="center top">
          <div style="width: 100px;height: 100px;border: 2px solid #000000;border-radius: 100%;display: inline-block;margin-bottom: 10px " /><br>
          (оттиск печати,
          присвоенной
          отправителю)
        </td>
        <td
          width="300"
          class="center top"
        >
          <table
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td class="bb">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                (подписи руководителя и ответственных работников юридического
              </td>
            </tr>
            <tr>
              <td class="bb">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                лица, сдающих почтовые отправления)
              </td>
            </tr>
          </table>
          <div style="margin-top: 20px">
            Принял________________________________________
          </div>
          (должность, подпись)
        </td>
        <td class="center top">
          <div style="width: 100px;height: 100px;border: 2px solid #000000;display: inline-block;margin-bottom: 10px " /><br>(оттиск календарного
          штемпеля места
          приема)
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode'

export default {
  name: 'OrderWaybill',
  components: { VueBarcode },
  props: {
    data: {
      type: Object,
      default () {
        return null
      },
    },
  },
}
</script>

<style type="text/css" scoped>
*, ::after, ::before {
  box-sizing: border-box;
}
body {
  margin: 0
}

.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}

body.A4 .sheet {
  width: 210mm;
  height: 296mm
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm
}

.sheet.padding-15mm {
  padding: 15mm
}

.sheet.padding-20mm {
  padding: 20mm
}

.sheet.padding-25mm {
  padding: 25mm
}
table {
  border-collapse: collapse;
  width: 100%
}
th {
  text-align: inherit;
  text-align: -webkit-match-parent;
  vertical-align: middle;
}
table td, table th {
  padding: 5px 5px;
  vertical-align: middle;
  height: 32px;
}
table td.bb{
  border-bottom: 1px solid #000000;
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #dee2e6;
}
table td.top{
  vertical-align: top;
}
table td.middle{
  vertical-align: middle;
}
table td.right{
  text-align: right;
}
table td.center{
  text-align: center;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0
  }

  .sheet {
    background: white;
    box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);
    margin: 5mm auto;
  }
  .sheet *{
    font-family: arial;
    color: #000000;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  body.A4 {
    width: 210mm
  }
  body{
    font-size: 16px;
  }
  .sheet *{
    font-family: "Times New Roman", Arial;
    color: #000000;
  }
  .page-break  {
    display:block;
    page-break-after:always;
    margin-top: 2cm;
  }

  @page { margin: 0; }

  body { margin: 1.6cm; }
}
</style>
